import { render } from "./OnboardingController.vue?vue&type=template&id=411df4e7"
import script from "./OnboardingController.vue?vue&type=script&lang=js"
export * from "./OnboardingController.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__